import React, {useEffect, useState} from "react";
import styles from "./index.less";
import {Card, message, Button, Flex, Tag, Spin, Modal} from "antd";
import HttpTool from "../../../tool/HttpTool";
import {CheckSquareFilled, CloseSquareFilled} from "@ant-design/icons";
import ModalBase from "../../../components/modalBase/index";
import APILXD from "../../../http/APILXD";
import VipPriceList from "./VipPriceList";
import ServerComboSel from "./component/ServerComboSel";
import Help from "../../../tool/Help";

const MB = new ModalBase();

export default function UserVipSet(props) {
  const [loading, setLoading] = useState(false);
  const [vipConfig, setVipConfig] = useState();

  useEffect(() => {
    getVipConfig()
  },[])

  const getVipConfig = async () => {
    setLoading(true)
    HttpTool.post(APILXD.vipList,(code,msg,data)=>{

      let formatData = {};
      data.forEach((eachItem)=>{
        if(eachItem.level === 0){
          formatData.normal = eachItem;
        }
        if(eachItem.level === 1){
          formatData.vip = eachItem;
        }
      })
      
      setVipConfig(formatData)
      setLoading(false)
    },(code,msg)=>{
      message.error(msg)
      setLoading(false)
    },{})
  }

  //获取权益表单项
  const getEditItem = (defaultData)=>{
    let defaultOption = {
      type: "inputNumber",
      ver: true,
      reg: (v)=>{
        return typeof v === "number" && v>=0
      },
      verMessage: "请配置数量",
      required: true,
    };
    let props = {
      colCount: 1,
      formItemLayout: {
        labelCol: { span: 10 },
        wrapperCol: { span: 12, offset: 0 },
      },
      parameterArr: [
        {
          ...defaultOption,
          field: "humanCreateCount",
          name: "免费创造数字人",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: '个',
            defaultValue: defaultData?.humanCreateCount
          }
        },
        {
          ...defaultOption,
          field: "capCount",
          name: "购买技能数量",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: '个',
            defaultValue: defaultData?.capCount
          }
        },
        {
          ...defaultOption,
          field: "positionCount",
          name: "购买职位数量",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: '个',
            defaultValue: defaultData?.positionCount
          }
        },
        {
          ...defaultOption,
          field: "combonSel",
          type: "diy",
          component: ServerComboSel,
          name: "算力免费使用",
          reg: (v)=>{
            return !!v
          },
          verMessage: "请选择套餐",
          option: {
            placeholder: '请选择套餐',
            style: {width: "100%"},
            popupMatchSelectWidth: false,
            defaultValue: defaultData?.pricePackageId || undefined
          },
        },
        {
          ...defaultOption,
          field: "tableDataSize",
          name: "表格可存储",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: 'G',
            defaultValue: defaultData?.tableDataSize
          }
        },
        {
          ...defaultOption,
          field: "fileDataSize",
          name: "文件可存储",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: 'G',
            defaultValue: defaultData?.fileDataSize
          }
        },
        {
          ...defaultOption,
          field: "userDev",
          type: "switch",
          name: "免费成为开发者",
          reg: ()=>{
            return true
          },
          option: {
            // disabled: true,
            defaultValue: defaultData?.userDev
          }
        },
        {
          ...defaultOption,
          field: "humanCustom",
          type: "switch",
          name: "支持数字人定制",
          reg: ()=>{
            return true
          },
          option: {
            // disabled: true,
            defaultValue: defaultData?.humanCustom
          }
        },
      ],
    };
    return {
      props,
      otherParam: null
    }
  }

  //编辑普通会员权益
  const editEquityForNormal = (defaultData)=>{
    let addData = getEditItem(defaultData);
    MB.show(
      {
        title: "编辑普通会员权益",
        okTitle: "确定",
        closeTitle: "取消",
        width: 500,
      },
      addData.props
      ,
      {
        url: APILXD.editVip,
        otherParam: {
          _id: defaultData._id
        },
        beforeSubmit: (param) => {
          if(param.combonSel){
            param.pricePackageId = param.combonSel.value;
            param.computePowerCount = param.combonSel.countLimit;
            param.tokenCount = param.combonSel.agentCountLimit;
          }
          param.userDev = !!param.userDev

          return true;
        },
        callBack: (state, msg) => {
          //添加成功回调
          state === 'success' && getVipConfig();
        }
      });
  }

  //编辑vip会员权益
  const editEquityForVip = (defaultData)=>{
    let addData = getEditItem(defaultData);
    MB.show(
      {
        title: "编辑Plus会员权益",
        okTitle: "确定",
        closeTitle: "取消",
        width: 500,
      },
      addData.props
      ,
      {
        url: APILXD.editVip,
        otherParam: {
          _id: defaultData._id
        },
        beforeSubmit: (param) => {
          if(param.combonSel){
            param.pricePackageId = param.combonSel.value;
            param.computePowerCount = param.combonSel.countLimit;
            param.tokenCount = param.combonSel.agentCountLimit;
          }

          return true;
        },
        callBack: (state, msg) => {
          //添加成功回调
          state === 'success' && getVipConfig();
        }
      });
  }

  //编辑标签
  const editTagForVip = (defaultData)=>{
    MB.show(
      {
        title: "编辑Plus会员标签",
        okTitle: "确定",
        closeTitle: "取消",
        width: 500,
      },
      {
        colCount: 1,
        formItemLayout: {
          labelCol: { span: 6 },
          wrapperCol: { span: 16, offset: 0 },
        },
        parameterArr: [
          {
            field: "tags",
            name: "会员标签",
            type: 'selectAll',
            selectType: 'value',
            required: false,
            ver: true,
            reg: (v) => {
              if(!v?.length){
                return true
              }

              return !(v.some((item) => {return item.length>5}))
            },
            verMessage: "每个标签最多使用5个字符",
            data: [],
            option: {
              mode: "tags",
              allowClear: true,
              placeholder: "请选择或填写标签",
              dropdownMatchSelectWidth: false,
              showSearch: true,
              onSearch: () => { },
              filterOption: (input, option) => {
                return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              },
              optionFilterProp: "children",
              defaultValue: defaultData?.tags?.length?defaultData?.tags.map((name)=>{
                return {
                  key: name,
                  value: name,
                  title: name
                }
              }):[]
            }
          },
        ],
      }
      ,
      {
        url: APILXD.editVip,
        otherParam: {
          _id: defaultData._id
        },
        beforeSubmit: (param) => {

          if(param.tags?.length){
            param.tags =  param.tags.map((item)=>{
              return typeof item === "string" ? item : item.value;
            });
          }

          return true;
        },
        callBack: (state, msg) => {
          //添加成功回调
          state === 'success' && getVipConfig();
        }
      });
  }


  //编辑价格
  const editPriceForVip = ()=>{
    Modal.info({
      title: "Plus会员价格配置",
      width: "90vw",
      centered: true,
      maskClosable: false,
      closable: true,
      okText: "完成",
      content: <div
        style={{height: "70vh", position: "relative", overflow: "auto"}}
      >
        <VipPriceList
          {...props}
          productType={"user_vip"}
        />
      </div>,
      afterClose: ()=>{
        getVipConfig()
      }
    })
  }

  return <div
    className={styles.fullPage}
  >
    <Spin
      spinning={loading}
    >
      <Flex gap={20} wrap={true}>
        <Card
          title={"普通会员"}
          style={{ width: 500}}
        >
          <Flex
            gap={20}
            vertical={true}
          >
            <div>
              <div className={styles.cardItemTitle}>
                <div>会员权益</div>
                <Button
                  type={"link"}
                  onClick={()=>{
                    editEquityForNormal(vipConfig?.normal)
                  }}
                >编辑权益</Button>
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>免费创造数字人 <span className={styles.vipItemValue}> {vipConfig?.normal?.humanCreateCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>购买技能数量 <span className={styles.vipItemValue}> {vipConfig?.normal?.capCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>购买职位数量 <span className={styles.vipItemValue}> {vipConfig?.normal?.positionCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>算力免费使用次数：服务器算力 <span className={styles.vipItemValue}> {vipConfig?.normal?.computePowerCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>算力免费使用次数：Agent算力 <span className={styles.vipItemValue}> {vipConfig?.normal?.tokenCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>表格可存储 <span className={styles.vipItemValue}> {vipConfig?.normal?.tableDataSize} G</span>
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>文件可存储 <span className={styles.vipItemValue}> {vipConfig?.normal?.fileDataSize} G</span>
              </div>
              <div>
                {
                  vipConfig?.normal?.userDev
                    ?<CheckSquareFilled className={styles.check}/>
                    :<CloseSquareFilled className={styles.notCheck}/>
                }
                免费成为开发者
              </div>
              <div>
                {
                  vipConfig?.normal?.humanCustom
                    ?<CheckSquareFilled className={styles.check}/>
                    :<CloseSquareFilled className={styles.notCheck}/>
                }
                支持数字人定制
              </div>
            </div>
            <div>
              <div className={styles.cardItemTitle}>
                <div>会员价格</div>
              </div>
              <div className={styles.priceBox}>
                <div>0 灵能</div>
              </div>
            </div>
          </Flex>
        </Card>
        <Card
          title={"Plus会员"}
          style={{ width: 500}}
        >
          <Flex
            gap={20}
            vertical={true}
          >
            <div>
              <div className={styles.cardItemTitle}>
                <div>会员权益</div>
                <Button
                  type={"link"}
                  onClick={()=>{
                    editEquityForVip(vipConfig?.vip)
                  }}
                >编辑权益</Button>
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>免费创造数字人 <span className={styles.vipItemValue}> {vipConfig?.vip?.humanCreateCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>购买技能数量 <span className={styles.vipItemValue}> {vipConfig?.vip?.capCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>购买职位数量 <span className={styles.vipItemValue}> {vipConfig?.vip?.positionCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>算力免费使用次数：服务器算力 <span className={styles.vipItemValue}> {vipConfig?.vip?.computePowerCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>算力免费使用次数：Agent算力 <span className={styles.vipItemValue}> {vipConfig?.vip?.tokenCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>表格可存储 <span className={styles.vipItemValue}> {vipConfig?.vip?.tableDataSize} G</span>
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>文件可存储 <span className={styles.vipItemValue}> {vipConfig?.vip?.fileDataSize} G</span>
              </div>
              <div>
                {
                  vipConfig?.vip?.userDev
                    ?<CheckSquareFilled className={styles.check}/>
                    :<CloseSquareFilled className={styles.notCheck}/>
                }
                免费成为开发者
              </div>
              <div>
                {
                  vipConfig?.vip?.humanCustom
                    ?<CheckSquareFilled className={styles.check}/>
                    :<CloseSquareFilled className={styles.notCheck}/>
                }
                支持数字人定制
              </div>
            </div>
            <div>
              <div className={styles.cardItemTitle}>
                <div>会员价格</div>
                <Button
                  type={"link"}
                  onClick={()=>{
                    editPriceForVip(vipConfig?.vip)
                  }}
                >编辑价格</Button>
              </div>
              {
                vipConfig?.vip?.pricePackageList?.length
                  ?(vipConfig?.vip?.pricePackageList?.sort((a,b)=>{return a.monthLimit - b.monthLimit})?.map((item, index) => {
                    return <div
                      key={'t_' + index}
                      className={styles.priceBox}
                    >
                      <div
                      >
                        {item.price/100} 灵能
                      </div>
                      <div
                      >
                        {Help.getDurationTimeShow(item.monthLimit,item.monthLimitUnit)}
                      </div>
                    </div>
                  }))
                  : "暂未配置"
              }
            </div>
            <div>
              <div className={styles.cardItemTitle}>
                <div>会员标签</div>
                <Button
                  type={"link"}
                  onClick={()=>{
                    editTagForVip(vipConfig?.vip)
                  }}
                >编辑标签</Button>
              </div>
              {
                vipConfig?.vip?.tags?.length
                  ?vipConfig?.vip?.tags.map((name)=>{
                    return <Tag color={"darkorange"}>{name}</Tag>
                })
                  :'无标签'
              }
            </div>
          </Flex>
        </Card>
      </Flex>
    </Spin>
  </div>
}